import { AppCard, AppCardContent } from '@app/components/base/app-card';
import { webApi } from '@mi-front/api-clients';
import { ReactNode } from 'react';
import { buildFragmentNavigationParams } from './fragment-navigation';
import { FragmentCardFooter } from './FragmentCardFooter';
import { FragmentCardTitle } from './FragmentCardTitle';
import { fragmentGridCardContentSx } from './styles';

/**
 * Shared card wrapper for fragment cards: layout and click navigation to fragment view.
 * Uses AppCard with internal router Link so the card is a real link (Ctrl/Cmd+click opens in new tab).
 * Renders optional media (e.g. poster), then body content, then footer.
 */
export function FragmentCardBase({
  fragment,
  media,
  content,
}: {
  fragment: webApi.FragmentListItemDto;
  /** Optional media area (e.g. poster for video cards). */
  media?: ReactNode;
  /** Main content rendered inside the card body. */
  content?: ReactNode;
}) {
  const to = buildFragmentNavigationParams(fragment);

  return (
    <AppCard to={to} media={media} footer={<FragmentCardFooter fragment={fragment} />}>
      <AppCardContent sx={fragmentGridCardContentSx}>
        {content ?? <FragmentCardTitle title={fragment.title} />}
      </AppCardContent>
    </AppCard>
  );
}
